import React, { Component, Fragment } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import ProgressBar from '../../artzu-ui/src/ProgressBar';

class ProgressHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // renderQuiz = () => {
  //   const { title } = this.props;
  //   return (
  //     <Fragment>
  //       {title}
  //       <span className="new-course__header--title--avt">
  //         &nbsp;>&nbsp;Quiz
  //       </span>
  //     </Fragment>
  //   );
  // };

  // renderAVT = () => {
  //   const { page, title } = this.props;
  //   return (
  //     <Fragment>
  //       {title}
  //       <span className="new-course__header--title--avt">
  //         &nbsp;>&nbsp;AVT&nbsp;0{page}
  //       </span>
  //     </Fragment>
  //   );
  // };

  renderSubHeader = page => {
    const { title } = this.props;
    return (
      <Fragment>
        {title}
        <span className="new-course__header--title--avt">
          {page === 6 ? <span>&nbsp;>&nbsp;Quiz</span> : <span>&nbsp;>&nbsp;AVT&nbsp;0{page}</span>}
        </span>
      </Fragment>
    );
  };

  render() {
    const {
      onClick,
      title,
      disable,
      goToSaved,
      back,
      persistentTitle,
      page
    } = this.props;

    return (
      <Fragment>
        <div className="new-course__header">
          <div className="new-course__header--container container">
            <div className="new-course__header--content">
              {back ? (
                <FontAwesomeIcon
                  className="new-course__header--icon"
                  icon={faArrowLeft}
                  onClick={evt => {
                    onClick();
                    evt.stopPropagation();
                  }}
                />
              ) : null}
              <div
                className={`new-course__header--title ${
                  back ? 'new-course__header--title--margin-right' : ''
                }`}>
                {/* {page === 6 ? this.renderQuiz() : this.renderAVT()} */}
                {page === 0 ? title : this.renderSubHeader(page)}
                {/* {title}
                <span className="new-course__header--title--avt">{` > AVT 0${page}`}</span> */}
              </div>
              <div className="new-course__header--progress">
                {page === 0 || page === 6 ? null : (
                  <ProgressBar fillers={[100 / 6 * page]} />
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ProgressHeader;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewCourseHeader.js